module.exports = __webpack_public_path__ + "static/media/leta.96a66330.mp3";